/* FORCIANO: collection-list "click to preview products" dropdown.
   Clicking a collection tile toggles a panel with that collection's products
   directly below the row (single panel open at a time), instead of
   navigating straight to the collection page. The "view all" link inside
   the panel still navigates to the full collection page.
   SPEED: the product cards are NOT in the page HTML. They are fetched on demand
   (first click, or hover/touch/focus prefetch) from <collection-url>?view=fcd
   (templates/collection.fcd.liquid) and injected into the panel. */
(function () {
  function getPanel(trigger) {
    var panelId = trigger.getAttribute('data-fcd-panel');
    return panelId ? document.getElementById(panelId) : null;
  }

  function ensureLoaded(panel) {
    if (!panel) return Promise.resolve();
    if (panel._fcdPromise) return panel._fcdPromise;

    var body = panel.querySelector('[data-fcd-body]');
    if (!body || body.getAttribute('data-fcd-loaded') === 'true') return Promise.resolve();

    var url = body.getAttribute('data-fcd-url');
    var cols = body.getAttribute('data-fcd-cols') || '4';
    var sliderId = body.getAttribute('data-fcd-slider-id') || '';

    panel._fcdPromise = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('fcd ' + response.status);
        return response.text();
      })
      .then(function (html) {
        body.innerHTML =
          '<slider-element' + (sliderId ? ' id="' + sliderId + '"' : '') +
          ' class="grid slider slider--desktop slider--tablet fcd-panel__slider" selector=".card-grid>.card">' +
          '<motion-list class="product-grid card-grid card-grid--' + cols + ' mobile:card-grid--3 grid">' +
          html +
          '</motion-list></slider-element>';
        body.setAttribute('data-fcd-loaded', 'true');
      })
      .catch(function () {
        panel._fcdPromise = null; // allow retry
        throw new Error('fcd load failed');
      });

    return panel._fcdPromise;
  }

  function closeTrigger(trigger) {
    if (!trigger) return;
    var panel = getPanel(trigger);
    var link = trigger.querySelector('a');

    trigger.classList.remove('is-open');
    if (link) link.setAttribute('aria-expanded', 'false');

    if (!panel) return;

    panel.style.maxHeight = panel.scrollHeight + 'px';
    window.requestAnimationFrame(function () {
      panel.style.maxHeight = '0px';
    });
    panel.classList.remove('is-open');

    window.setTimeout(function () {
      if (!trigger.classList.contains('is-open')) {
        panel.hidden = true;
        panel.style.maxHeight = '';
      }
    }, 400);
  }

  function openTrigger(trigger) {
    if (!trigger) return;
    var panel = getPanel(trigger);
    var link = trigger.querySelector('a');

    trigger.classList.add('is-open');
    if (link) link.setAttribute('aria-expanded', 'true');

    if (!panel) return;

    panel.hidden = false;
    panel.style.maxHeight = '0px';
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });

    // Content may still be loading: once it arrives, let the panel grow freely.
    ensureLoaded(panel).then(function () {
      if (trigger.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        window.setTimeout(function () {
          if (trigger.classList.contains('is-open')) panel.style.maxHeight = 'none';
        }, 420);
      }
    }).catch(function () {
      // Fallback: go to the collection page.
      if (link && link.href) window.location.href = link.href;
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.fcdInitialized === 'true') return;
    root.dataset.fcdInitialized = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-fcd-trigger]'));
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      var link = trigger.querySelector('a');
      if (link) {
        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');
      }

      // Prefetch on intent so the panel is usually ready when the click lands.
      var prefetch = function () {
        ensureLoaded(getPanel(trigger)).catch(function () {});
      };
      trigger.addEventListener('mouseenter', prefetch, { passive: true });
      trigger.addEventListener('touchstart', prefetch, { passive: true });
      trigger.addEventListener('focusin', prefetch);

      trigger.addEventListener('click', function (event) {
        var anchor = event.target.closest('a');
        if (!anchor || !trigger.contains(anchor)) return;

        event.preventDefault();

        var isOpen = trigger.classList.contains('is-open');

        triggers.forEach(function (otherTrigger) {
          if (otherTrigger !== trigger && otherTrigger.classList.contains('is-open')) {
            closeTrigger(otherTrigger);
          }
        });

        if (isOpen) {
          closeTrigger(trigger);
        } else {
          openTrigger(trigger);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-forciano-collection-dropdown]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the theme editor swaps a section back in.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector('[data-forciano-collection-dropdown]')
      : null;
    if (root) initRoot(root);
  });
})();